/*
 * --------------------------------------------------------------------
 * File: \src\app\appSlice.js
 * Created: Wednesday, 25th September 2024 12:26:33 pm
 * Modified: Wednesday, 25th September 2024 12:26:33 pm
 * Author: Mohamed Kamil Bin Mansor
 * 
 * Copyright (c) 2024 - System Consultancy Services Sdn. Bhd.
 * --------------------------------------------------------------------
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: "MainGIS",
  gisModule: "",
  selectedGisModule: {},
  selectedDashboardModule: {},
  openGisDrawer: false,
  superModule: "EkonomiPintar",
  catageryModule: "Hasil",
  mainModule: "Hasil",
  dialogOpen: false,
  dialogContent: "",
  successOpen: false,
  successContent: "",
  exceptionType: "",
}

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setGisModule: (state, action) => {
      state.gisModule = action.payload;
    },
    setDashboardModule: (state, action) => {
      state.dashboardModule = action.payload;
    },
    setSelectedGisModule: (state, action) => {
      state.selectedGisModule = action.payload;
    },
    setOpenGisDrawer: (state, action) => {
      state.openGisDrawer = action.payload;
    },
    setSuperModule: (state, action) => {
      state.superModule = action.payload;
    },
    setCategoryModule: (state, action) => {
      state.catageryModule = action.payload;
    },
    setMainModule: (state, action) => {
      state.mainModule = action.payload;
    },
    setDialogOpen: (state, action) => {
      state.dialogOpen = action.payload;
    },
    setDialogContent: (state, action) => {
      state.dialogContent = action.payload;
    },
    setSuccessOpen: (state, action) => {
      state.successOpen = action.payload;
    },
    setSuccessContent: (state, action) => {
      state.successContent = action.payload;
    },
    setExceptionType: (state, action) => {
      state.exceptionType = action.payload;
    }
  },
});

export const { setPage, setGisModule, setDashboardModule, setSelectedGisModule, setUserProfile, setOpenGisDrawer, setSuperModule, setCategoryModule, setMainModule, setDialogOpen, setDialogContent,setSuccessOpen,setSuccessContent, setExceptionType } =
  appSlice.actions;

export const getPage = (state) => state.app.page;
export const getGisModule = (state) => state.app.gisModule;
export const getDashboardModule = (state) => state.app.dashboardModule;
export const getSelectedGisModule = (state) => state.app.selectedGisModule;
export const getUserProfile = (state) => state.app.userProfile;
export const getOpenGisDrawer = (state) => state.app.openGisDrawer;
export const getSuperModule = (state) => state.app.superModule;
export const getCategoryModule = (state) => state.app.catageryModule;
export const getMainModule = (state) => state.app.mainModule;
export const getDialogOpen = (state) => state.app.dialogOpen;
export const getDialogContent = (state) => state.app.dialogContent;
export const getSuccessOpen = (state) => state.app.successOpen;
export const getSuccessContent = (state) => state.app.successContent;
export const getExceptionType = (state) => state.app.exceptionType;

export default appSlice.reducer;